export default __webpack_public_path__ + "static/media/microsoft-logo.3fd9d274.jpg";